const _isLoading = ref(false)

export function provideGlobalState() {
  provide('isLoading', _isLoading)
}

export function useGlobalState() {
  const isLoading = inject('isLoading', _isLoading)
  return { isLoading }
}
